import React, { FC, useMemo } from 'react'
import { PrintLayout } from 'components/Layout'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { parseToDate } from 'lib/helper'
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
import { PrintDeliveryOrderTemplate } from 'components/Templates'
import { StockUnionType } from 'types/stock'

const PrintDeliveryOrder: FC = () => {
  const router = useSelector((state: State) => state.router)
  const pathname = router.location.pathname
  const { status } = router.location.query
  const date = /\/order\/delivery\/print\/.+/.test(pathname) ? pathname.split('/order/delivery/print/')[1] : undefined
  const currentDate = date ? parseToDate(date) : new Date()
  const title = `${format(currentDate, 'M月d日(E)', { locale: ja })}のお届け`
  const types = useMemo(() => ['delivery' as StockUnionType], [])
  return (
    <PrintLayout title={title}>
      <PrintDeliveryOrderTemplate currentDate={currentDate} date={date} status={status} title={title} types={types} />
    </PrintLayout>
  )
}

export default PrintDeliveryOrder
